import { connect } from 'react-redux';
import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import moment from 'moment';
import { setFilterByDates } from 'modules/queues/Schedule/actions/appointmentsFilters';
import { getDateRangeDescription } from 'modules/queues/Schedule/selectors/appointmentsFilters';

import FilterByDateRange from './FilterByDateRange';


const getThisDay = () => ({
  'startDate': moment().startOf('day').toDate(),
  'endDate': moment().endOf('day').toDate(),
});

const getThisWeek = () => ({
  'startDate': moment().startOf('week').toDate(),
  'endDate': moment().endOf('week').toDate(),
});

const getThisMonth = () => ({
  'startDate': moment().startOf('month').toDate(),
  'endDate': moment().endOf('month').toDate(),
});


export const mapDispatchToProps = (dispatch) => ({
  setStartDate: startDate => dispatch(setFilterByDates({ startDate: moment(startDate).startOf('day').toDate() })),
  setEndDate: endDate => dispatch(setFilterByDates({ endDate: moment(endDate).endOf('day').toDate() })),
  setTodayDate: () => dispatch(setFilterByDates(getThisDay())),
  setThisWeekDate: () => dispatch(setFilterByDates(getThisWeek())),
  setThisMonthDate: () => dispatch(setFilterByDates(getThisMonth())),
});

export default compose(
  injectIntl,

  connect(
    (state, ownProps) => ({
      startDate: state.queues.schedule.appointmentsFilters.dateRange.startDate,
      endDate: state.queues.schedule.appointmentsFilters.dateRange.endDate,
      description: getDateRangeDescription(state, ownProps),
    }),
    mapDispatchToProps,
  ),
)(FilterByDateRange);
